export const RequestHeaders = {
    headers: { Accept: 'application/json' },
};
//# sourceMappingURL=utilities.js.map